import { Container, Typography } from '@mui/material';
import React from 'react';
import EnhancedTable from '../../../../../../lib/designSystem/Table';

const SiiComercialYearsHeaders = [
  { key: 'year', label: 'Año comercial' },
  { key: 'businessIdentifier', label: 'RUT' },
  { key: 'businessName', label: 'Razón social' },
  { key: 'salesSegment', label: 'Tramo según ventas' },
  { key: 'minSalesSegment', label: 'Ventas mínimas (anual)', type: 'money' },
  { key: 'maxSalesSegment', label: 'Ventas máximas (anual)', type: 'money' },
  { key: 'collaborators', label: 'N° de trabajadores' },
  {
    key: 'firstCreatedDate',
    label: 'Inicio actividades',
    type: 'date',
  },
  {
    key: 'finalizedDate',
    label: 'Término actividads',
    type: 'date',
  },
  { key: 'constributorType', label: 'Tipo Contribuyente' },
  { key: 'constributorSubType', label: 'SubTipo Contribuyente' },
  { key: 'economicSegment', label: 'Rubro económico' },
  { key: 'economicSubSegment', label: 'Subrubro económico' },
  { key: 'economicActivity', label: 'Actividad económica' },
  { key: 'region', label: 'Región' },
  { key: 'province', label: 'Provincia' },
  { key: 'commune', label: 'Comuna' },
  { key: 'Rpresunt', label: 'R_PRESUNTA' },
  { key: 'OtherRegimes', label: 'OTROS_REGIMENES' },
];

const CommercialYearsTable = ({ data }: any) => {
  if (!data.length)
    return (
      <div style={{ padding: '0px' }}>
        <Typography variant="body1">
          {'No se encontraron resultados'}
        </Typography>
      </div>
    );
  return (
    <>
      <Typography fontWeight={600} variant="h6">
        Años anteriores
      </Typography>
      <Container>
        <EnhancedTable
          exportToFile="xlsx"
          dataHeaders={SiiComercialYearsHeaders}
          data={data || []}
          rowsPerPageDefault={10}
        />
      </Container>
    </>
  );
};

export default CommercialYearsTable;
